var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomizeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 3.5C5.3 2.67157 5.97157 2 6.8 2C7.62843 2 8.3 2.67157 8.3 3.5V4.4H8.9C9.73869 4.4 10.158 4.4 10.4888 4.53702C10.9299 4.71971 11.2803 5.07012 11.463 5.51117C11.6 5.84195 11.6 6.26131 11.6 7.1H12.5C13.3284 7.1 14 7.77157 14 8.6C14 9.42843 13.3284 10.1 12.5 10.1H11.6V11.12C11.6 12.1281 11.6 12.6321 11.4038 13.0172C11.2312 13.3559 10.9559 13.6312 10.6172 13.8038C10.2321 14 9.72809 14 8.72 14H8.3V12.95C8.3 12.2044 7.69558 11.6 6.95 11.6C6.20442 11.6 5.6 12.2044 5.6 12.95V14H4.88C3.87191 14 3.36786 14 2.98282 13.8038C2.64412 13.6312 2.36875 13.3559 2.19618 13.0172C2 12.6321 2 12.1281 2 11.12V10.4077H2.9C3.72843 10.4077 4.4 9.73612 4.4 8.90769C4.4 8.07926 3.72843 7.40769 2.9 7.40769H2C2 6.569 2 5.84195 2.13702 5.51117C2.31971 5.07012 2.67012 4.71971 3.11117 4.53702C3.44195 4.4 3.86131 4.4 4.7 4.4H5.3V3.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeWhite);
export default __webpack_public_path__ + "static/media/customize_white.713d35c13b8c52271b47d14262eac436.svg";
export { ForwardRef as ReactComponent };